import { createSlice } from "@reduxjs/toolkit";

export const createPasswordSlice = createSlice({
  name: "createPassword",
  initialState: {
    data: null,
    error: null,
    isLoading: false
  },
  reducers: {
    startCreatePassword: (state) => { state.isLoading = true; },
    setCreatePassword: (state, { payload: { data = null, error = null } = {}} = {}) => {
      state.data = data;
      state.error = error;
      state.isLoading = false;
    }
  }
});

export const { startCreatePassword, setCreatePassword } = createPasswordSlice.actions;
